import React from "react";
import "./styles.scss";

const SettingsCard = () => (
  <div className="settings-card">
    <h3>Admin Settings</h3>
    <p>Configure your admin dashboard settings here.</p>
  </div>
);

export default SettingsCard;
